module.exports = __webpack_public_path__ + "img/zubut-icon.9d778a8b.svg";